module.exports = __webpack_public_path__ + "57152358ceb3ddeaa47f57d6cd16e7f1.jpg";